import Button from "Components/button";
import includes from "lodash/includes";
import isNumber from "lodash/isNumber";
import styled from "styled-components";
export default {
    Button: styled(Button)
        .withConfig({
        shouldForwardProp: (prop) => !includes(["height"], prop)
    })
        .attrs({
        className: "dropdown-toggle btn-default overflow-hidden"
    }) `
    && {
      padding-top: 0;
      padding-bottom: 0;
      display: grid;
      align-content: center;
    }
    max-width: 100%;
    align-items: center;
    max-height: ${({ theme, height }) => (isNumber(height) ? `${height}px` : height) || theme["input-height-base"]};
  `
};
